import React from 'react';
import { observer } from 'mobx-react-lite';
import { useInitialSeedProductTemplatesStore } from 'store/pages/rfq/rfq-template/initial-seed-product-templates/pageStore';
import { Button, Checkbox } from '@insurancemenu/imenu-components-lib';
import SendOutEmailsModal from 'components/common/modals/SendOutEmailsModal';
import { CloudUpload } from '@insurancemenu/imenu-components-lib/dist/icons';
import { GROUP_MAINTENANCE_FORM_ID, RATE_MAINTENANCE_FORM_ID } from 'components/rfq/product-template/constants';
import { ActionPanelStyled, FiltersWrapperStyled, RightSectionStyled } from './styles';
import UploadJsonModal from '../../UploadJsonModal';
import { ReportActionsDropdown } from './ReportActionsDropdown';

const ActionPanel: React.FC = observer(() => {
  const {
    paginationDelegate,
    uploadJsonModalDelegate,
    groupMaintenanceReportsModalStore,
    rateMaintenanceReportsModalStore,
  } = useInitialSeedProductTemplatesStore();

  return (
    <>
      <ActionPanelStyled>
        <FiltersWrapperStyled>
          <Checkbox
            label="With Errors"
            checked={!!paginationDelegate.filters.hasValidationErrors}
            onChange={() => {
              paginationDelegate.setFilterValue(
                'hasValidationErrors',
                !paginationDelegate.filters.hasValidationErrors ? true : null, // null turns off filtering
              );
              paginationDelegate.setFilterValue('doesNotHaveBenefitsFile', null);
            }}
          />
          <Checkbox
            label="No Benefits File"
            checked={!!paginationDelegate.filters.doesNotHaveBenefitsFile}
            onChange={() => {
              paginationDelegate.setFilterValue(
                'doesNotHaveBenefitsFile',
                !paginationDelegate.filters.doesNotHaveBenefitsFile ? true : null, // null turns off filtering
              );
              paginationDelegate.setFilterValue('hasValidationErrors', null);
            }}
          />
        </FiltersWrapperStyled>
        <RightSectionStyled>
          <Button color="primary" size="large" onClick={uploadJsonModalDelegate.open} leftIconProp={<CloudUpload />}>
            Batch Upload JSON&apos;S
          </Button>
          <ReportActionsDropdown />
        </RightSectionStyled>
      </ActionPanelStyled>
      <UploadJsonModal />
      <SendOutEmailsModal
        title="Request Group Maintenance Reports"
        subtitle="Enter your email and we’ll send you the report once it is ready."
        modalStore={groupMaintenanceReportsModalStore}
        formId={GROUP_MAINTENANCE_FORM_ID}
      />
      <SendOutEmailsModal
        title="Request Rate Maintenance Reports"
        subtitle="Enter your email and we’ll send you the report once it is ready."
        modalStore={rateMaintenanceReportsModalStore}
        formId={RATE_MAINTENANCE_FORM_ID}
      />
    </>
  );
});

export default ActionPanel;
